import get from 'lodash/get';

const styles = theme => ({
  infoButton: {
    padding: get(theme, 'padding.p6'),
  },
  messageContainer: {
    fontSize: get(theme, 'fontSize.smallText'),
    fontFamily: get(theme, 'typography.bodyText'),
    padding: get(theme, 'padding.p6'),
  },
  iconInfo: {
    fontSize: 30,
  },
  infoContainer: {
    width: '5%',
    float: 'left',
  },
  closeButton: {
    float: 'right',
    padding: get(theme, 'padding.p6'),
  },
});

export default styles;
